<div class="container-xxl p-2 p-md-3 p-lg-4 container_global">
  <!-- Tabella ticket assegnati nascosta temporaneamente
  <div class="row px-0">
    @if (dashboardTicketAssigned) {
      <app-table-assigned-ticket-s
        [tickets]="dashboardTicketAssigned"
      ></app-table-assigned-ticket-s>
    }
  </div>
  -->

  <div class="row pt-4">
    @for (data of dashboardData; track data.filterType) {
      <div class="col-12 my-2">
        <div class="card">
          <div
            class="card-header"
            [class.card-header--with-action]="data.filterType === 'ticket'"
          >
            <h4 class="card-title">
              {{ getTranslateName(data.title_it, data.title_en) }} -
              {{ getTranslateName(data.labelperiod_it, data.labelperiod_en) }}
            </h4>
            @if (data.filterType === 'ticket') {
              <a
                class="btn btn-sm btn-outline-primary card-header__dashboard"
                [routerLink]="['/' + data.path]"
              >
                {{ "DASHBOARD.WECO.GENERIC.DASHBOARD" | translate }}
              </a>
            }
          </div>
          <div class="card-body">
            <div
              [ngClass]="
                data.count_batteries !== undefined
                  ? 'd-flex justify-content-between gap-2'
                  : ''
              "
            >
              <div
                class="badge rounded-pill text-primary bg-primary-subtle px-3 py-2 dashboard-badge"
              >
                <span class="dashboard-badge__label">
                  {{ "DASHBOARD.WECO.GENERIC.NUMBER" | translate }}
                  {{ getTranslateName(data.title_it, data.title_en) }}:
                </span>
                <span class="dashboard-badge__value">
                  {{ data.count_new }}
                </span>
              </div>
              @if (data.count_batteries !== undefined) {
                <div
                  class="badge rounded-pill text-primary bg-primary-subtle px-3 py-2 dashboard-badge"
                >
                  <span class="dashboard-badge__label">
                    {{ "DASHBOARD.WECO.GENERIC.NUMBER_BATTERIES" | translate }}:
                  </span>
                  <span class="dashboard-badge__value">
                    {{ data.count_batteries }}
                  </span>
                </div>
              }
            </div>
            <div class="chart mt-3">
              <div class="card shadow-sm h-100">
                <div class="card-body">
                  <div class="d-flex flex-column gap-3">
                    @for (status of data.status; track status.id) {
                      <div
                        class="status-row"
                        [class.status-row--clickable]="!!data.path_table"
                        (click)="navigateWithStatusFilter(data, status)"
                      >
                        <div class="d-flex justify-content-between small mb-1">
                          <span class="fw-medium">{{
                            getTranslateName(status.name_it, status.name_en)
                          }}</span>
                          <div class="block">
                            <span class="fw-semibold"
                              >{{ status.count }} - </span
                            ><span>({{ status.percentage }}%)</span>
                          </div>
                        </div>
                        <div class="progress" style="height: 6px">
                          <div
                            class="progress-bar"
                            role="progressbar"
                            [style.width.%]="status.percentage"
                            [style.background-color]="status.color"
                            aria-valuemin="0"
                            aria-valuemax="100"
                          ></div>
                        </div>
                      </div>
                    }
                    @if (data.status.length === 0) {
                      <div
                        class="d-flex flex-column align-items-center justify-content-center h-100"
                      >
                        <span class="text-muted">
                          {{ "DASHBOARD.WECO.GENERIC.NO_DATA" | translate }}
                        </span>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
            <div class="bottom">
              <a
                class="btn btn-outline-primary"
                [routerLink]="['/' + data.path]"
              >
                {{
                  (data.filterType === "ticket"
                    ? "DASHBOARD.WECO.GENERIC.DASHBOARD"
                    : "DASHBOARD.WECO.GENERIC.DETAIL"
                  ) | translate
                }}
              </a>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>
